import Vue from 'vue'

/**
 *
 * @param {Object} state - vuex state
 * @param {Boolean} isLoading
 */
export const setIsLoading = (state, isLoading) => {
    Vue.set(state, 'isLoading', isLoading)
}

const mutations = {
    setRetrievedItems(state, { items }) {
        Vue.set(state, 'list', items)
    },

    setCreatedItem(state, { item }) {
        state.list.push(item)
    },

    setUpdatedItem(state, { item }) {
        state.list = state.list.map(it => {
            if (parseInt(it['id']) === parseInt(item.id)) {
                for (const key in item) {
                    if (typeof it[key] !== 'undefined') {
                        it[key] = item[key]
                    }
                }
            }
            return it
        })
    },

    setDeletedItem(state, { id }) {
        state.list = state.list.filter(item => {
            return item['id'] !== id
        })
    },

    setBooleanFieldItem(state, { id, field }) {
        state.list = state.list.map(item => {
            item[field] = parseInt(item.id) === parseInt(id) ? !item[field] : false
            return item
        })
    },

    setIsLoading
}

export default mutations
